import SideBarAccordion from '@ui/SideBarAccordion/SideBarAccordion';

export default SideBarAccordion;
